import { Check, X } from 'lucide-react'
import { passwordStrength } from '@/lib/passwordStrength'

/** Bar colour per strength score (index 0 = empty). */
const BAR_COLORS = ['bg-gray-200', 'bg-red-400', 'bg-amber-400', 'bg-lime-500', 'bg-green-500']

/** Live password strength feedback: a 4-segment bar, the hard requirements, and a strength label. */
export default function PasswordStrengthMeter({ password }: { password: string }) {
  if (!password) return null
  const s = passwordStrength(password)
  return (
    <div className="-mt-2 mb-3">
      <div className="flex gap-1 mb-1.5">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full ${i < s.score ? BAR_COLORS[s.score] : 'bg-gray-200'}`}
          />
        ))}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <Req ok={s.meetsMin} text="10+ characters" />
        <Req ok={s.hasLetter} text="a letter" />
        <Req ok={s.hasDigit} text="a number" />
        <span className={`ml-auto text-[11px] font-medium ${s.valid ? 'text-green-600' : 'text-gray-400'}`}>
          {s.label}
        </span>
      </div>
    </div>
  )
}

function Req({ ok, text }: { ok: boolean; text: string }) {
  return (
    <span className={`flex items-center gap-0.5 text-[11px] ${ok ? 'text-green-600' : 'text-gray-400'}`}>
      {ok ? <Check size={11} /> : <X size={11} />} {text}
    </span>
  )
}
